var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hdr-patient-list"}},[_c('MainHeader',{attrs:{"cState":"治未病数据"}}),_c('div',{staticClass:"main"},[_c('HdrLeftNav',{attrs:{"cState":"健康档案"}}),_c('SizhenPatients')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }